import type { CSSProperties, ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'span' | 'div';
}

export const Title = ({
  children,
  style,
  className,
  as: Tag = 'h2',
}: TitleProps) => (
  <Tag
    className={className}
    style={{
      fontSize: 20,
      fontWeight: 600,
      color: '#262626',
      fontFamily: '"Inter Tight", "HK Grotesk SemiBold", -apple-system, "Segoe UI", sans-serif',
      margin: 0,
      ...style,
    }}
  >
    {children}
  </Tag>
);
